import React from 'react';
import NumberFormat from 'react-number-format';
import { fdate } from './helpers';
import { FRONT_DF_1 } from '../CONST';

export const headerOperation = (instance, align = 'center') => (
  <div className={`text-${align} table-header`}>{instance}</div>
);

export const headerDoubleRowOperation = (instance1, instance2) => (
  headerOperation((
    <>
      <div>{instance1}</div>
      <div>{instance2}</div>
    </>
  ))
);

export const cellOperation = (instance, align = 'center', wrap = true) => (
  <div className={`text-${align} table-cell ${wrap ? 'wrap' : ''}`}>
    {instance || instance === 0 ? instance : '-'}
  </div>
);

export function cellNumOperation(instance, align, decimals) {
  return (
    <div className={`text-${align || 'right'} table-cell`}>
      <NumberFormat
        decimalScale={decimals || '2'}
        fixedDecimalScale
        decimalSeparator=","
        displayType="text"
        value={instance}
        thousandSeparator="."
      />
    </div>
  );
}

export const cellDobleRowOperation = (row1, row2) =>
  cellOperation(
    <>
      <div>{row1}</div>
      <div>{row2}</div>
    </>,
    'center',
  );

export const cellDateOperation = (instance, format = FRONT_DF_1) =>
  cellOperation(fdate(instance, format));
